import styled from 'styled-components'

import theme, { rem } from '../../utils/theme'

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${rem(10)};
`

const StyledImage = styled.img`
  height: ${rem(110)};
  width: ${rem(110)};
  padding: ${rem(5)};
  border: ${theme.borders.default};
  border-radius: 5px;
  object-fit: cover;
  flex-shrink: 0;
  margin-right: ${rem(25)};
`
const StyledTextContainer = styled.div`
  width: 100%;
  min-width: ${rem(200)};
  line-height: ${rem(12)};
  strong {
    font-weight: 700;
  }
`

const TeamSummary = ({ teamName, teamCode, teamEmail, teamContact, teamLogo }) => {
  return (
    <StyledContainer>
      {teamLogo && <StyledImage src={teamLogo} alt="Team Logo Image" />}
      <StyledTextContainer>
        {teamName && (
          <p>
            Team Name: <strong>{teamName}</strong>
          </p>
        )}
        {teamCode && (
          <p>
            Team Code: <strong>{teamCode}</strong>
          </p>
        )}
        {teamEmail && (
          <p>
            Team Email: <strong>{teamEmail}</strong>
          </p>
        )}
        {teamContact && (
          <p>
            Team Manager: <strong>{teamContact}</strong>
          </p>
        )}
      </StyledTextContainer>
    </StyledContainer>
  )
}

export default TeamSummary
